import { lazy } from 'react';

export const ErrorBoundary = lazy(() => import('./ErrorBoundary.component'));
